export enum PaymentInfoType {
  Stripe = 'STRIPE',
  BankSlip = 'BANK_SLIP',
  Invoice = 'INVOICE',
  Delegate = 'DELEGATE',
}
